exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.unconfirmed-order[data-v-404a61eb] {\n  background-color: #ffde3c;\n}\n.ksef-failed[data-v-404a61eb] {\n  background-color: #f36969;\n}\n[data-v-404a61eb] table.v-table thead th {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n[data-v-404a61eb] table.v-table tbody td {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n", ""]);

// exports
